import * as React from 'react';
import { SelectItem } from '../types';
import { SelectedOption } from './selected-option';
import { LoadOptions } from '../..';
import { numberOfLevels } from '../constants';
import styles from './selected-options.scss';
import { isNumeric } from 'app/infrastructure/data/number';
import { ValidationProps } from 'ui/common/validation';
import { sortSelectedItems } from 'ui/common/select/selected-options/sort-selected-items';

export interface SelectedOptionsProps {
  componentId: string;
  items: SelectItem[];
  loadOptions?: (loadOptions: LoadOptions) => void;
  readOnly?: boolean;
  onChange: (items: SelectItem[]) => void;
  validation?: ValidationProps;
  locale: string;
}

export class SelectedOptions extends React.Component<SelectedOptionsProps> {

  private handleOnClick = (item: SelectItem) => {
    this.props.loadOptions({
      siblingId: Number(item.value),
      levels: numberOfLevels
    });
  };

  private handleOnRemove = (removedItem: SelectItem) => {
    if (this.props.readOnly) {
      return;
    }
    const items = this.props.items.filter(item => item.value !== removedItem.value);
    this.props.onChange(items);
  };

  private renderItem = (index: number, item: SelectItem) => {
    const valueIsValid = isNumeric(item.value) ? item.value > -1 : !!item.value;
    const showItem = item.value !== null && item.value !== undefined && valueIsValid;
    const hasValidationError = this.props?.validation?.messages?.some?.(
      message => message?.parameters?.id === item?.value
    );

    return showItem
      && <SelectedOption
        key={index}
        item={item}
        hasError={!!hasValidationError}
        onClick={this.handleOnClick}
        onRemove={!item.readOnly && this.handleOnRemove}
        readOnly={this.props.readOnly || item.readOnly}
      />;
  };

  public render() {
    const { items = [], componentId } = this.props;
    const hasItems = items?.length > 0;
    const selectedSortedOptions = hasItems && sortSelectedItems(items, this.props.locale);

    return hasItems ? <div id={`selected-options-${componentId}`} className={styles.listOfItems}>
      {selectedSortedOptions.map((item, index) => this.renderItem(index, item))}
    </div> : null;
  }
}
